// @ts-nocheck
import { DefaultValues, FieldValues, useForm, UseFormReturn } from 'react-hook-form';
import { ZodType } from 'zod';
import zodToJsonSchema from 'zod-to-json-schema';
import { zodResolver } from '@hookform/resolvers/zod';

export interface UseFormProps<T> {
  formSchema: ZodType<any, any, any>;
  formDefaultValues: T;
  schemaTitle: string;
}

export interface ExtendedUseFormReturn<T extends FieldValues> extends UseFormReturn<T> {
  formProperties: any;
  formMethods: UseFormReturn<T>;
}

export const useFormHook = <T extends FieldValues>({
  formSchema,
  formDefaultValues,
  schemaTitle,
}: UseFormProps<T>): ExtendedUseFormReturn<T> => {
  const formMethods = useForm<T>({
    mode: 'onTouched',
    resolver: zodResolver(formSchema),
    reValidateMode: 'onChange',
    defaultValues: formDefaultValues as DefaultValues<T>,
  }) as UseFormReturn<T>;

  const jsonSchema = zodToJsonSchema(formSchema, schemaTitle).definitions?.[schemaTitle] as any;

  const formProperties = jsonSchema?.properties;
  // @ts-expect-error - TS doesn't know about formProperties
  formMethods.formProperties = formProperties;
  return { ...formMethods, formProperties, formMethods };
};

export const createEnum = <T extends string>(keys: T[]): { [K in T]: K } =>
  keys.reduce((acc, key) => {
    acc[key] = key;
    return acc;
  }, Object.create(null));
